"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _FoodMenu = require("../../../FoodMenu.context");

var _modifiers = require("../modifiers");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

require("./Item.css");

var ItemModal = function ItemModal(_ref) {
  var trigger = _ref.trigger,
      id = _ref.id,
      name = _ref.name,
      description = _ref.description,
      price = _ref.price,
      image = _ref.image;
  return _react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var items = _ref2.items,
        modifierSets = _ref2.modifierSets;

    var item = _menu["default"].getItemById(items, id);

    var itemModifierSetIds = item.modifier_sets;

    var itemModifierSets = _menu["default"].getItemModifierSets(itemModifierSetIds, modifierSets);

    return _react["default"].createElement(_semanticUiReact.Modal, {
      trigger: trigger,
      dimmer: "inverted"
    }, _react["default"].createElement(_semanticUiReact.Modal.Content, null, _react["default"].createElement(_semanticUiReact.Grid, null, _react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: image ? 8 : 16
    }, _react["default"].createElement("div", {
      className: "fcfm-item-modal-header"
    }, _react["default"].createElement(_semanticUiReact.Header, null, name), _react["default"].createElement("p", null, "$", price)), _react["default"].createElement("p", null, description), itemModifierSets.map(function (_ref3) {
      var id = _ref3.id;
      return _react["default"].createElement(_modifiers.ModifierSetBasic, {
        modifierSetId: id
      });
    })), image && _react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 8
    }, _react["default"].createElement(_semanticUiReact.Image, {
      src: image,
      fluid: true
    })))));
  });
};

var _default = ItemModal;
exports["default"] = _default;